import config from '../config';

export const formatYears = (years: number): string => {
  return new Intl.NumberFormat(config.language, {
    style: 'unit',
    unit: 'year',
    unitDisplay: 'long',
  }).format(years);
};
